import { render } from "./clock.vue?vue&type=template&id=466cde40"
import script from "./clock.vue?vue&type=script&lang=js"
export * from "./clock.vue?vue&type=script&lang=js"

import "./clock.vue?vue&type=style&index=0&id=466cde40&lang=less"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__